// import "./App.css";
// import { useEffect, useState, useRef } from "react";
// import Lenis from "@studio-freight/lenis";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// import { Helmet } from "react-helmet-async";
// import TechLoader from "./Conponents/TechLoader"
// import heroVideo from "./Assets/main-project.mp4"


// import { Suspense, lazy } from "react";


// gsap.registerPlugin(ScrollTrigger);


// const ServiceDetail = lazy(() => import("./Conponents/ServiceDetail"));

// const Hero = lazy(() => import("./Conponents/Hero"));
// const SecondPage = lazy(() => import("./Conponents/SecondPage"));
// const ThirdPage = lazy(() => import("./Conponents/ThirdPage"));
// const PortfolioSection = lazy(() => import("./Conponents/PortfolioSection"));
// const TestimonialsSection = lazy(() => import("./Conponents/TestimonialsSection"));
// const ContactSection = lazy(() => import("./Conponents/ContactSection"));
// const SwastiqText = lazy(() => import("./Conponents/SwastiqText"));
// const Footer = lazy(() => import("./Conponents/Footer"));

// // import { useLocation } from "react-router-dom";
// // import { scrollToSection } from "./utility/ScrollToSection";

// // Home Page Wrapper
// function Home() {
//   useEffect(() => {
//     // let layout settle after all lazy chunks mount, then recalc triggers
//     const id = requestAnimationFrame(() => ScrollTrigger.refresh());
//     return () => cancelAnimationFrame(id);
//   }, []);
//   return (
//     <>
//       <Helmet>
//         <title>
//           Swastiq TechDesigns | Web Development & SEO Company in India
//         </title>
//         <meta
//           name="description"
//           content="Swastiq TechDesigns provides Web Development, SEO, Graphic Design, Social Media Management and Digital Solutions for growing businesses in India."
//         />
//         <link
//           rel="canonical"
//           href="https://swastiq.co.in/"
//         />
//       </Helmet>

//       <Suspense fallback={<TechLoader />}>
//         <Hero />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <SecondPage />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <ThirdPage />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>

//         <PortfolioSection />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <TestimonialsSection />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <ContactSection />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <SwastiqText />
//       </Suspense>

//       <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
//         <Footer />
//       </Suspense>
//     </>
//   );
// }

// // function App() {
// //   useEffect(() => {
// //     if (window.innerWidth < 768) return; // disable on mobile

// //     const lenis = new Lenis({
// //       duration: 1.2,
// //       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
// //       smoothWheel: true,
// //     });

// //     function raf(time) {
// //       lenis.raf(time);
// //       requestAnimationFrame(raf);
// //     }

// //     requestAnimationFrame(raf);

// //     return () => {
// //       lenis.destroy();
// //     };
// //   }, []);

// //   return (
// //     <Router>
// //       <div className="swastiq_main">
// //         <Suspense fallback={<div className="loader">Loading...</div>}>
// //           <Routes>
// //             <Route path="/" element={<Home />} />
// //             <Route path="/services/:slug" element={<ServiceDetail />} />
// //           </Routes>
// //         </Suspense>
// //       </div>
// //     </Router>
// //   );
// // }


// // function App() {
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const timer = setTimeout(() => {
// //       setLoading(false);
// //     }, 3500);

// //     return () => clearTimeout(timer);
// //   }, []);

// //   useEffect(() => {
// //     if (window.innerWidth < 768) return;

// //     const lenis = new Lenis({
// //       duration: 1.2,
// //       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
// //       smoothWheel: true,
// //     });

// //     function raf(time) {
// //       lenis.raf(time);
// //       requestAnimationFrame(raf);
// //     }

// //     requestAnimationFrame(raf);

// //     return () => {
// //       lenis.destroy();
// //     };
// //   }, []);

// //   if (loading) {
// //     return <TechLoader />;
// //   }

// //   return (
// //     <Router>
// //       <div className="swastiq_main">
// //         <Suspense fallback={null}>
// //           <Routes>
// //             <Route path="/" element={<Home />} />
// //             <Route path="/services/:slug" element={<ServiceDetail />} />
// //           </Routes>
// //         </Suspense>
// //       </div>
// //     </Router>
// //   );
// // }
// function App() {
//   const [loading, setLoading] = useState(true);
//   const lenisRef = useRef(null);

//   // Real readiness instead of a fixed timer
//   useEffect(() => {
//     let cancelled = false;

//     const video = document.createElement("video");
//     video.src = heroVideo;
//     video.preload = "auto";

//     const finish = () => {
//       if (cancelled) return;
//       setLoading(false);
//     };

//     // Hide loader once the hero video can play through, capped at 4s
//     // so a slow network never blocks the site indefinitely
//     const safety = setTimeout(finish, 4000);
//     video.addEventListener("canplaythrough", () => {
//       clearTimeout(safety);
//       finish();
//     });

//     return () => {
//       cancelled = true;
//       clearTimeout(safety);
//     };
//   }, []);

//   useEffect(() => {
//     const isDesktop = window.innerWidth >= 768;
//     let lenis;

//     if (isDesktop) {
//       lenis = new Lenis({
//         duration: 1.2,
//         easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
//         smoothWheel: true,
//       });
//       lenisRef.current = lenis;

//       // Single clock: GSAP's ticker drives Lenis, and ScrollTrigger
//       // stays perfectly in sync with it — no more competing rAF loops
//       lenis.on("scroll", ScrollTrigger.update);
//       gsap.ticker.add((time) => {
//         lenis.raf(time * 1000);
//       });
//       gsap.ticker.lagSmoothing(0);
//     }

//     return () => {
//       if (lenis) lenis.destroy();
//       gsap.ticker.remove(lenis?.raf);
//     };
//   }, []);

//   if (loading) {
//     return <TechLoader />;
//   }

//   return (
//     <Router>
//       <div className="swastiq_main">
//         <Suspense fallback={null}>
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/services/:slug" element={<ServiceDetail />} />
//           </Routes>
//         </Suspense>
//       </div>
//     </Router>
//   );
// }

// export default App;

import "./App.css";
import { useEffect, useState, useRef } from "react";
import Lenis from "@studio-freight/lenis";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import TechLoader from "./Conponents/TechLoader";
import heroPosterImg from "./Assets/VideoSubstitute.jpg";
import { Suspense, lazy } from "react";

gsap.registerPlugin(ScrollTrigger);

// React.lazy() wrappers — kept so Suspense semantics still work
const ServiceDetail = lazy(() => import("./Conponents/ServiceDetail"));
const Hero = lazy(() => import("./Conponents/Hero"));
const SecondPage = lazy(() => import("./Conponents/SecondPage"));
const ThirdPage = lazy(() => import("./Conponents/ThirdPage"));
const PortfolioSection = lazy(() => import("./Conponents/PortfolioSection"));
const TestimonialsSection = lazy(() => import("./Conponents/TestimonialsSection"));
const ContactSection = lazy(() => import("./Conponents/ContactSection"));
const SwastiqText = lazy(() => import("./Conponents/SwastiqText"));
const Footer = lazy(() => import("./Conponents/Footer"));

// Eagerly fire the SAME import() calls in parallel. Once these resolve,
// the chunks sit in webpack's module cache — so when React.lazy asks for
// them below, Suspense resolves on the same tick instead of waiting.
// This is what gives you "one clean reveal" instead of pieces popping in.
const preloadHomeChunks = () =>
  Promise.all([
    import("./Conponents/Hero"),
    import("./Conponents/SecondPage"),
    import("./Conponents/ThirdPage"),
    import("./Conponents/PortfolioSection"),
    import("./Conponents/TestimonialsSection"),
    import("./Conponents/ContactSection"),
    import("./Conponents/SwastiqText"),
    import("./Conponents/Footer"),
  ]);

function Home() {
  return (
    <>
      <Helmet>
        <title>Swastiq TechDesigns | Web Development & SEO Company in India</title>
        <meta
          name="description"
          content="Swastiq TechDesigns provides Web Development, SEO, Graphic Design, Social Media Management and Digital Solutions for growing businesses in India."
        />
        <link rel="canonical" href="https://swastiq.co.in/" />
      </Helmet>

      {/* fallback={null} is safe here — by the time Home mounts,
          preloadHomeChunks() has already resolved, so Suspense never
          actually suspends; there is no pop-in to mask. */}
      <Suspense fallback={null}>
        <Hero />
        <SecondPage />
        <ThirdPage />
        <PortfolioSection />
        <TestimonialsSection />
        <ContactSection />
        <SwastiqText />
        <Footer />
      </Suspense>
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  const lenisRef = useRef(null);

  // Gate the loader on EVERYTHING that affects layout: fonts (font
  // swaps reflow text), the hero poster, and every section's JS chunk.
  // Nothing pops in after this resolves — the page is fully built
  // before the user can touch it.
  useEffect(() => {
    let cancelled = false;

    const fontsReady = document.fonts ? document.fonts.ready : Promise.resolve();

    const posterReady = new Promise((resolve) => {
      const img = new Image();
      img.src = heroPosterImg;
      if (img.complete) return resolve();
      img.onload = resolve;
      img.onerror = resolve;
    });

    const safety = setTimeout(() => {
      if (!cancelled) setLoading(false);
    }, 5000); // absolute ceiling so a stalled request never traps someone

    Promise.all([fontsReady, posterReady, preloadHomeChunks()]).then(() => {
      if (cancelled) return;
      clearTimeout(safety);
      // Two rAFs: first lets React commit the now-fully-resolved tree,
      // second lets the browser actually paint it before we unhide.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!cancelled) setLoading(false);
        });
      });
    });

    return () => {
      cancelled = true;
      clearTimeout(safety);
    };
  }, []);

  // Hard-lock scroll while loading. Nobody can be "mid-scroll" while
  // the layout is still forming — this alone removes most of the race.
  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading]);

  // Lenis + GSAP only start AFTER the page is fully settled — never
  // during load, never reactively on resize afterward.
  useEffect(() => {
    if (loading) return;

    const isDesktop = window.innerWidth >= 768;
    let lenis;
    let tickerFn;

    if (isDesktop) {
      lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      window.lenis = lenis;
      lenisRef.current = lenis;

      tickerFn = (time) => {
        lenis.raf(time * 1000);
      };

      gsap.ticker.add(tickerFn);
      gsap.ticker.lagSmoothing(0);

      lenis.on("scroll", ScrollTrigger.update);

      ScrollTrigger.defaults({
        scroller: document.documentElement,
      });
    }

    // ONE refresh, once, against a layout that is now fully final.
    // No ResizeObserver, no repeated refresh mid-session — that
    // reactive refresh was fighting Lenis during live scrolling.
    const raf = requestAnimationFrame(() => ScrollTrigger.refresh());

    return () => {
      cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      if (tickerFn) gsap.ticker.remove(tickerFn);
    };
  }, [loading]);

  if (loading) {
    return <TechLoader />;
  }

  return (
    <Router>
      <div className="swastiq_main">
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;